export default "__VITE_ASSET__de4e4d54__"